module.exports = __webpack_public_path__ + "img/horses_online.6a363e71.png";